import gsap from 'gsap'
import { Flip, ScrollTrigger, SplitText } from 'gsap/all'

gsap.config({
  autoSleep: 120,
  nullTargetWarn: process.env.NODE_ENV === 'development'
})

gsap.ticker.fps(100)

const SCROLLTRIGGER_CONFIG: ScrollTrigger.ConfigVars = {
  syncInterval: 100,
  limitCallbacks: true
}
const SCROLLTRIGGER_NORMALIZE = true
const SCROLLTRIGGER_DEFAULTS: ScrollTrigger.Vars = {}

export {
  Flip,
  gsap,
  ScrollTrigger,
  SCROLLTRIGGER_CONFIG,
  SCROLLTRIGGER_DEFAULTS,
  SCROLLTRIGGER_NORMALIZE,
  SplitText
}
